<template lang="html">
  <div class="question-container">
    <div class="close-icon-div">
      <v-btn flat icon @click = "$emit('close')"><i class="close-icon"></i></v-btn>
      <span class="question-number">{{ `${index+1} / ${totalNumberOfQuestion}` }}</span>
    </div>
    <div class="title--txt">
      <vue-markdown :source = "taskCompletionItem.task_completion_text">{{ taskCompletionItem.task_completion_text }}</vue-markdown>
    </div>
    <div class="welcome-txt">
      <v-btn v-if="!showMap" large class="upload mt-100 white--text" @click="allowLocationAccess()">Give Location Access</v-btn>
      <google-map v-if="showMap":longitude="longitude" :latitude="latitude"></google-map>
    </div>
    <div class="button-container" :class="{'top-map': showMap, 'top-no-map': !showMap}">
      <v-btn flat small class="edit" @click = "$emit('previous')"><span>Back</span></v-btn>
      <v-btn :disabled="!showMap" large @click = "$emit('next'); submitTaskCompletionItemValue();" class="next-button">Next</v-btn>
    </div>
  </div>
</template>

<script>
import GoogleMap from '@/components/googleMap';
import VueMarkdown from 'vue-markdown';

export default {
  components: {
    GoogleMap,
    VueMarkdown,
  },
  props: {
    index: {
      type: Number,
    },
  },
  data() {
    return {
      latitude: '',
      longitude: '',
      showMap: false,
      totalNumberOfQuestion: null,
    };
  },
  computed: {
    taskCompletionItem() {
      const items = this.$store.getters['completionQuestions/taskCompletionList'];
      this.totalNumberOfQuestion = items.length;
      return items[this.index] || {};
    },
  },
  methods: {
    allowLocationAccess() {
      navigator.geolocation.getCurrentPosition(
        this.success,
        this.error,
        { enableHighAccuracy: true },
      );
    },
    success(pos) {
      const crd = pos.coords;
      this.latitude = crd.latitude;
      this.longitude = crd.longitude;
      this.showMap = true;
    },
    submitTaskCompletionItemValue() {
      this.$store.dispatch('completionQuestions/submitTaskCompletionItem', {
        location_lat: String(this.latitude),
        location_lng: String(this.longitude),
        task_completion_item_id: this.taskCompletionItem.task_completion_item_id,
      });
      this.defaultState();
    },
    defaultState() {
      this.latitude = '';
      this.longitude = '';
      this.showMap = false;
    },
    error() {
      this.showMap = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/shared.scss";
@import "~styles/completion_questions.scss";

#app {
  input {
    width: 100%;
  }
  .top-map {
    top: 4%;
  }
  .top-no-map {
    top: 28%;
  }
  .mt-100 {
    margin-top: 100px;
  }
  .upload {
    border-radius: 24px;
    background: $primary;
    font-family: MuseoSans-900;
    font-size: 16px;
  }
  .button-container {
    flex-grow: 3;
  }

  .title--txt {
    flex-grow: 5;
  }
  .welcome-txt {
    flex-grow: 17;
  }

  @media only screen and (min-width:500px) {
    .button-container {
      text-align: center;
    }
  }

  @media only screen and (max-width:499px) {
    .question-number {
      margin-left: 33%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionsTypes/LocationQuestion.vue